/**
 * Embed mode PostMessage sender.
 * Sends AFFINE_READY when workspace loads and AFFINE_ROUTE_CHANGE on navigation.
 * Only active when environment.isEmbedMode is true.
 *
 *  * environment is a global set by setupGlobal() — no import needed.
 * The type declaration in tools/@types/env/__all.d.ts makes it available.
 */

const AFFINE_SOURCE = 'affine';

export const EMBED_MESSAGES = {
  READY: 'AFFINE_READY',
  ROUTE_CHANGE: 'AFFINE_ROUTE_CHANGE',
  ERROR: 'AFFINE_ERROR',
} as const;

function getParentOrigin(): string | null {
  if (!environment.isEmbedMode || !window.parent || window.parent === window) {
    return null;
  }
  const origin = environment.embedParentOrigin;
  // Validate: must be a proper https origin, not empty or wildcard
  if (!origin || origin === '*' || !origin.startsWith('https://')) {
    return null;
  }
  return origin;
}

function sendToParent(type: string, payload?: Record<string, unknown>) {
  const origin = getParentOrigin();
  if (!origin) return;

  window.parent.postMessage(
    { type, source: AFFINE_SOURCE, payload },
    origin
  );
}

// Guard: only send READY once per session (isRootDocReady may toggle on workspace switch)
let readySent = false;

export function sendReady() {
  if (readySent) return;
  readySent = true;
  sendToParent(EMBED_MESSAGES.READY);
}

export function sendRouteChange(path: string, title?: string) {
  sendToParent(EMBED_MESSAGES.ROUTE_CHANGE, { path, title });
}

export function sendError(message: string) {
  sendToParent(EMBED_MESSAGES.ERROR, { message });
}
